// utils/fileUtils.js
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const formatFileSizeMB = (bytes) => {
  return (bytes / 1024 / 1024).toFixed(2);
};

export const validateFileType = (file, allowedTypes) => {
  if (!allowedTypes || allowedTypes.length === 0) return true;
  
  const fileExtension = file.name.split('.').pop().toLowerCase();
  return allowedTypes.includes(fileExtension);
};

export const validateFileSize = (file, maxSizeMB) => {
  if (!maxSizeMB) return true;
  
  const fileSizeMB = file.size / 1024 / 1024;
  return fileSizeMB <= maxSizeMB;
};

export const validateMultipleFiles = (files, maxFiles) => {
  if (!maxFiles) return true;
  return files.length <= maxFiles;
};

export const getAcceptedFormats = (types) => {
  if (!types || types.length === 0) return '';
  return types.map(type => `.${type}`).join(',');
};

export const getFileTypeDisplayText = (types) => {
  if (!types || types.length === 0) return 'All formats';
  return types.join(', ').toUpperCase();
};
